var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionCoopInfo } from "../cooperative/actionCoop";
import { TypeActionChat } from "./actionChat";
export var initial = {
    newMessages: [],
    unreadMessages: 0,
};
export var reducerChatInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionChat.ChatRoomInfoReceived && action.chatRoom != undefined) {
        return __assign({}, state, { chatRoom: action.chatRoom, newMessages: [] });
    }
    else if (action.type === TypeActionChat.AddNewMessageInChatRoom &&
        action.message != undefined) {
        return __assign({}, state, { newMessages: state.newMessages.concat([action.message]), unreadMessages: action.isChatTabOpen ? state.unreadMessages : state.unreadMessages + 1 });
    }
    else if (action.type === TypeActionChat.ResetUnreadMessageCount) {
        return __assign({}, state, { unreadMessages: 0 });
    }
    else if (action.type === TypeActionCoopInfo.LeaveCoop) {
        return initial;
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/reducerChatInfo.ts
// module id = 2520
// module chunks = 3